import { render, staticRenderFns } from "./ComponentActions.vue?vue&type=template&id=0bc07ff2&scoped=true&"
import script from "./ComponentActions.vue?vue&type=script&lang=js&"
export * from "./ComponentActions.vue?vue&type=script&lang=js&"
import style0 from "./ComponentActions.vue?vue&type=style&index=0&id=0bc07ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc07ff2",
  null
  
)

export default component.exports